module.exports = __webpack_public_path__ + "files/b73a0cb53642acf2fbf924c74f523281.png";